import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { FiltersData } from '../../state/ActivityLogV2/FiltersData';

const updateFiltersData: Reducer<FiltersData> = (state: FiltersData = new FiltersData(), action: Action<ActionType, FiltersData>) => {
  switch (action.type) {
    case ActionType.ACTIVITY_LOG_V2_FILTERS_UPDATED:
      return { ...state, ...action.data };
    case ActionType.ACTIVITY_LOG_V2_FILTERS_RESET:
      return new FiltersData();
    default:
      return state;
  }
};

export default updateFiltersData;
